"use client";
// import React, { useState, useCallback, useMemo } from "react";
// import { useAnalytics } from "@/hooks/useAnalytics";
// import { ContactAnalytics } from "@/lib/analyticsName";
import {
  Phone,
  Mail,
  // MapPin,
  Clock,
  // MessageCircle,
  // Send,
  // Bike,
  // ArrowRight,
  // CheckCircle,
  // Globe,
  // Shield,
  // Headphones,
} from "lucide-react";
import { CONTACT_US_DATA } from "@/lib/ConstData";

// interface FormData {
//   name: string;
//   email: string;
//   phone: string;
//   city: string;
//   service: string;
//   message: string;
// }

const ContactUsClient: React.FC = () => {
  // const [formData, setFormData] = useState<FormData>({
  //   name: "",
  //   email: "",
  //   phone: "",
  //   city: "",
  //   service: "",
  //   message: "",
  // });
  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const [activeField, setActiveField] = useState<string>("");
  // const [submitStatus, setSubmitStatus] = useState<"idle" | "success" | "error">("idle");
  // const { createClickHandler } = useAnalytics();

  // const handleInputChange = useCallback((
  //   e: React.ChangeEvent<
  //     HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
  //   >
  // ) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // }, []);

  // const handleSubmit = async () => {
  //   setIsSubmitting(true);
  //   setSubmitStatus("idle");

  //   try {
  //     // Simulate form submission
  //     await new Promise(resolve => setTimeout(resolve, 1000));
      
  //     // Track successful form submission
  //     const submitHandler = createClickHandler(
  //       () => {
  //         setSubmitStatus("success");
  //         setFormData({ name: "", email: "", phone: "", city: "", service: "", message: "" });
  //       },
  //       ContactAnalytics.Submit,
  //       ContactAnalytics.Category,
  //       {
  //         form_type: 'contact_us',
  //         has_name: !!formData.name,
  //         has_email: !!formData.email,
  //         has_phone: !!formData.phone,
  //         has_message: !!formData.message,
  //         message_length: formData.message.length
  //       }
  //     );
      
  //     // Call the handler without parameters
  //     submitHandler();
      
  //   } catch (error) {
  //     setSubmitStatus("error");
  //     console.error("Form submission failed:", error);
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  // const cities = useMemo(() => [
  //   "Delhi",
  //   "Mumbai",
  //   "Bangalore",
  //   "Chennai",
  //   "Kolkata",
  //   "Hyderabad",
  //   "Pune",
  //   "Ahmedabad",
  //   "Jaipur",
  //   "Lucknow",
  //   "Indore",
  //   "Bhopal",
  //   "Nagpur",
  //   "Vadodara",
  //   "Surat",
  // ], []);

  // const services = useMemo(() => [
  //   "Bike Rental",
  //   "Scooter Rental",
  //   "Long-term Rental",
  //   "Corporate Rental",
  //   "Event Rental",
  //   "Other",
  // ], []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-4 h-4 bg-blue-400 rounded-full animate-bounce"></div>
          <div className="absolute top-40 right-20 w-3 h-3 bg-cyan-400 rounded-full animate-pulse"></div>
          <div className="absolute bottom-32 left-1/4 w-2 h-2 bg-purple-400 rounded-full animate-ping"></div>
        </div>
        
        <div className="relative max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <div className="animate-fade-in-up">
            <h1 className="text-4xl md:text-6xl font-bold mb-8">
              Get in Touch with <span className="text-blue-200">RideNGo</span>
            </h1>
            <p className="text-xl text-blue-100 mb-12 max-w-2xl mx-auto leading-relaxed">
              Have questions about our bike rental services? Need help with a booking? 
              Our friendly team is here to assist you 24/7.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            {/* <div className="bg-white rounded-2xl p-8 shadow-xl">
              <h2 className="text-3xl font-bold text-gray-800 mb-8">Send us a Message</h2>
              
              <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      onFocus={() => setActiveField("name")}
                      onBlur={() => setActiveField("")}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
                        activeField === "name" ? "border-blue-500" : "border-gray-300"
                      }`}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      onFocus={() => setActiveField("email")}
                      onBlur={() => setActiveField("")}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
                        activeField === "email" ? "border-blue-500" : "border-gray-300"
                      }`}
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      onFocus={() => setActiveField("phone")}
                      onBlur={() => setActiveField("")}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
                        activeField === "phone" ? "border-blue-500" : "border-gray-300"
                      }`}
                      placeholder="Enter your phone number"
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      City *
                    </label>
                    <select
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      onFocus={() => setActiveField("city")}
                      onBlur={() => setActiveField("")}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
                        activeField === "city" ? "border-blue-500" : "border-gray-300"
                      }`}
                      required
                    >
                      <option value="">Select your city</option>
                      {cities.map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Service Required *
                  </label>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    onFocus={() => setActiveField("service")}
                    onBlur={() => setActiveField("")}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
                      activeField === "service" ? "border-blue-500" : "border-gray-300"
                    }`}
                    required
                  >
                    <option value="">Select a service</option>
                    {services.map((service) => (
                      <option key={service} value={service}>
                        {service}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Message *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    onFocus={() => setActiveField("message")}
                    onBlur={() => setActiveField("")}
                    rows={4}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
                      activeField === "message" ? "border-blue-500" : "border-gray-300"
                    }`}
                    placeholder="Tell us how we can help you..."
                    required
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full py-4 px-6 rounded-lg font-semibold text-white transition-all duration-200 flex items-center justify-center gap-2 ${
                    isSubmitting
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-600 hover:bg-blue-700 transform hover:scale-105"
                  }`}
                >
                  {isSubmitting ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Sending Message...
                    </>
                  ) : (
                    <>
                      <Send className="w-5 h-5" />
                      Send Message
                    </>
                  )}
                </button>

                {submitStatus === "success" && (
                  <div className="flex items-center gap-2 text-green-600 bg-green-50 p-4 rounded-lg">
                    <CheckCircle className="w-5 h-5" />
                    <span>Message sent successfully! We&apos;ll get back to you soon.</span>
                  </div>
                )}

                {submitStatus === "error" && (
                  <div className="flex items-center gap-2 text-red-600 bg-red-50 p-4 rounded-lg">
                    <MessageCircle className="w-5 h-5" />
                    <span>Failed to send message. Please try again.</span>
                  </div>
                )}
              </form>
            </div> */}

            {/* Contact Information */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-8">Contact Information</h2>
                <p className="text-lg text-gray-600 mb-8">
                  Reach out to us through any of these channels. Our team is available 24/7 to assist you.
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Phone Support</h3>
                    <p className="text-gray-600 mb-2">Call us anytime for immediate assistance</p>
                    <a
                      href={`tel:${CONTACT_US_DATA.phone}`}
                      className="text-blue-600 hover:text-blue-700 font-medium text-lg"
                    >
                      {CONTACT_US_DATA.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Email Support</h3>
                    <p className="text-gray-600 mb-2">Send us an email for detailed inquiries</p>
                    <a
                      href={`mailto:${CONTACT_US_DATA.supportEmail}`}
                      className="text-green-600 hover:text-green-700 font-medium text-lg"
                    >
                      {CONTACT_US_DATA.supportEmail}
                    </a>
                  </div>
                </div>

                {/* <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Service Areas</h3>
                    <p className="text-gray-600 mb-2">Available in 40+ cities across India</p>
                    <div className="flex flex-wrap gap-2">
                      {cities.slice(0, 8).map((city) => (
                        <span
                          key={city}
                          className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm"
                        >
                          {city}
                        </span>
                      ))}
                      <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm">
                        +{cities.length - 8} more
                      </span>
                    </div>
                  </div>
                </div> */}

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Business Hours</h3>
                    <p className="text-gray-600 mb-2">We&apos;re here for you 24/7</p>
                    <p className="text-orange-600 font-medium">24/7 Customer Support</p>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              {/* <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">Quick Actions</h4>
                <div className="space-y-3">
                  <button className="w-full flex items-center justify-between p-3 bg-white rounded-lg hover:bg-blue-50 transition-colors duration-200">
                    <span className="text-gray-700">Book a Bike</span>
                    <ArrowRight className="w-5 h-5 text-blue-600" />
                  </button>
                  <button className="w-full flex items-center justify-between p-3 bg-white rounded-lg hover:bg-blue-50 transition-colors duration-200">
                    <span className="text-gray-700">Check Availability</span>
                    <ArrowRight className="w-5 h-5 text-blue-600" />
                  </button>
                  <button className="w-full flex items-center justify-between p-3 bg-white rounded-lg hover:bg-blue-50 transition-colors duration-200">
                    <span className="text-gray-700">View Pricing</span>
                    <ArrowRight className="w-5 h-5 text-blue-600" />
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      {/* <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              Why Choose Our Support?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We provide comprehensive support to ensure your bike rental experience is smooth and enjoyable.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Headphones className="w-8 h-8 text-blue-600" />
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">24/7 Support</h4>
              <p className="text-gray-600">Round-the-clock assistance whenever you need us</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-green-600" />
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Expert Team</h4>
              <p className="text-gray-600">Experienced professionals ready to help you</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Globe className="w-8 h-8 text-purple-600" />
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Multi-channel</h4>
              <p className="text-gray-600">Contact us via phone, email, or live chat</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Bike className="w-8 h-8 text-orange-600" />
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Quick Response</h4>
              <p className="text-gray-600">Fast and efficient solutions to your queries</p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default ContactUsClient;
